import React, { FC } from "react";

import Button from "../../molecules/Button/Button";
import Links from "../../molecules/Links/Links";

import { NavbarLinksType } from "./Type";
import { DropdownLinks } from "../../molecules/Dropdown/Dropdown";

const NavbarLinks: FC<NavbarLinksType> = ({ links, buttons }) => {
  return (
    <div className="menus">
      <ul className="navbar__links">
        {links.length > 0 &&
          links.map((link, index: number) =>
            link.type === "link" && link.link ? (
              <li
                key={`${link.text}-${index}`}
                className={`navbar__links--link ${link.text && link.text.toLowerCase().replaceAll(" ", "-")}`}
              >
                <Links text={link.text} url={link.link} />
              </li>
            ) : (
              link.type === "dropdown" && <DropdownLinks key={`${link.text}-${index}`} dropdown={link} />
            ),
          )}
      </ul>

      <ul className="navbar__buttons">
        {buttons.length > 0 &&
          buttons.map((button: NavbarButtonItem, index: number) =>
            button.link ? (
              <li
                key={`${button.text}-${index}`}
                className={`--button ${
                  button.text && button.text.toLowerCase().replaceAll(" ", "-")
                }`}
              >
                <Button text={button.text} url={button.link} />
              </li>
            ) : (
              <></>
            ),
          )}
      </ul>
    </div>
  );
};

export default NavbarLinks;
